export default {"src":"/_next/static/media/triceps.b02262d9.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};